import React, { useEffect, useState } from 'react';
import { metaCallback } from '../services/auth';
import '../styles/WhatsAppConnect.css';

const WhatsAppConnect = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [sdkLoaded, setSdkLoaded] = useState(false);

  const APP_ID = "2136563960289032";
  const CONFIG_ID = "2013030356084448";

  useEffect(() => {
    // SDK initialization
    window.fbAsyncInit = function() {
      window.FB.init({
        appId: APP_ID,
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v20.0'
      });
      setSdkLoaded(true);
    };

    // Cargar el SDK si no está presente
    const loadSDK = () => {
      if (document.getElementById('facebook-jssdk')) return;
      const script = document.createElement('script');
      script.id = 'facebook-jssdk';
      script.src = 'https://connect.facebook.net/en_US/sdk.js';
      script.async = true;
      script.defer = true;
      script.crossOrigin = 'anonymous';
      document.body.appendChild(script);
    };

    loadSDK();

    // Session logging message event listener
    const handleMessage = (event) => {
      if (!event.origin.endsWith('facebook.com')) return;
      try {
        const data = JSON.parse(event.data);
        if (data.type === 'WA_EMBEDDED_SIGNUP') {
          console.log('message event: ', data);
        }
      } catch {
        console.log('message event: ', event.data);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [APP_ID]);

  // Response callback
  const fbLoginCallback = (response) => {
    if (response.authResponse) {
      const code = response.authResponse.code;
      console.log('response: ', code);
      handleCodeExchange(code);
    } else {
      console.log('response: ', response);
      setError('No se completó la autorización. Intenta de nuevo.');
    }
  };

  const handleCodeExchange = async (code) => {
    setIsLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await metaCallback(code);
      console.log('✅ Respuesta del backend:', response);
      setSuccess(true);
    } catch (err) {
      console.error('❌ Error en el callback de Meta:', err);
      setError(err.message || 'No se pudo conectar con WhatsApp. Intenta de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  // Launch method and callback registration
  const launchWhatsAppSignup = () => {
    if (!sdkLoaded || !window.FB) {
      setError('El SDK de Facebook aún no se ha cargado. Intenta de nuevo.');
      return;
    }

    setError(null);
    window.FB.login(fbLoginCallback, {
      config_id: CONFIG_ID,
      response_type: 'code',
      override_default_response_type: true,
      extras: {
        setup: {}
      }
    });
  };

  return (
    <div className="whatsapp-connect-container">
      <div className="whatsapp-connect-card">
        <h2>📱 Conectar WhatsApp Business</h2>
        <p>Conecta tu número de WhatsApp para activar el chatbot automático</p>

        {error && (
          <div className="whatsapp-connect-error">
            ❌ {error}
          </div>
        )}

        {success && (
          <div className="whatsapp-connect-success">
            ✅ ¡WhatsApp conectado exitosamente!
          </div>
        )}

        <div className="whatsapp-connect-button-wrapper">
          <button
            onClick={launchWhatsAppSignup}
            disabled={!sdkLoaded || isLoading || success}
            className="whatsapp-connect-button"
          >
            {isLoading ? 'Conectando...' : 'Login with Facebook'}
          </button>
          {!sdkLoaded && !error && <p className="sdk-loading-message">Cargando SDK de Facebook...</p>}
        </div>

        <div className="whatsapp-connect-info">
          <p>⚠️ Al conectar, aceptas los términos de Meta.</p>
          <p>🔒 Tus datos serán almacenados de forma segura veamos.</p>
        </div>
      </div>
    </div>
  );
};

export default WhatsAppConnect;